console.log('config Environment Variables: ', process.env);
export default {
  client: process.env.VUE_APP_CLIENT,
  baseURL: process.env.VUE_APP_BASEURL,
  ioURL: process.env.VUE_APP_IOURL
}
